import React from 'react';

import SubjectListItem from "./SubjectListItem";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Paper from '@mui/material/Paper';

interface ISubjectParent {
    _id: string;
    title: string;
    description: string;
    hash_key: string;
    quizObjectCount: number;
    image_url: string;
    public: boolean;
    enabled: boolean;
    user: string;
};

interface SubjectListDetailProps {
    title?: string;
    subjectList: ISubjectParent[];
    markComplete: Function
    showSubject: Function
}

function SubjectListDetail({title, markComplete, subjectList, showSubject}: SubjectListDetailProps) {
    console.log("Subject List");
    console.log(subjectList);
    return (
        <TableContainer>
        <Table>
            <TableHead>
            <TableRow> {/* className="subject-index-list-item subject-index-header"> */}
                <TableCell className="text-col text-col-first col-1">{subjectList.length}</TableCell>
                <TableCell className="text-col col-3">Subject</TableCell>
                <TableCell className="text-col col-5">Description</TableCell>
                <TableCell className="text-col col-1"># Cards</TableCell>
                <TableCell className="text-col col-1">Public</TableCell>
                <TableCell></TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {subjectList.map((subject: ISubjectParent, i: number) => {
                return (
                    <SubjectListItem
                        onClick={() => showSubject(subject.hash_key)}
                        markComplete={markComplete}
                        className="col-12"
                        key={subject._id}
                        description={subject.description}
                        hash_key={subject.hash_key}
                        image_url={subject.image_url}
                        public={subject.public}
                        quizObjectCount={subject.quizObjectCount}
                        title={subject.title}
                        user={subject.user}
                    ></SubjectListItem>
                );
            })}
            </TableBody>
        </Table>
        </TableContainer>
        );
};

export {
    SubjectListDetail,
}

export type { ISubjectParent };